import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-bottom-action-footer',
  templateUrl: './bottom-action-footer.component.html',
  styleUrls: ['./bottom-action-footer.component.scss']
})
export class BottomActionFooterComponent {
  @Input() buttonName: any;
  @Input() disbaleButton: any;
  @Output() onClickEvent = new EventEmitter();

  onClickAction() {
    this.onClickEvent.emit();
  }
}
